import PropTypes from "prop-types";

import { useGetProject } from "@/entities/project";
import FetchItemWrapper from "@/modules/fetch-item-wrapper";

import ProjectEdit from "./ProjectEdit.component";

const ProjectEditWrapper = ({ projectId }) => {
  const { project, isLoading } = useGetProject(projectId);

  return (
    <FetchItemWrapper
      item={project}
      loading={isLoading}
      renderContent={(project) => <ProjectEdit model={project} />}
    />
  );
};

ProjectEditWrapper.propTypes = {
  projectId: PropTypes.number.isRequired,
};

export default ProjectEditWrapper;
